import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Button, Stack, Typography, Grid2 } from "@mui/material";
import { PortableText } from "@portabletext/react";
import { navigate } from "gatsby";
import React from "react";
import COLORS from "../../constants/colors";
import BurningAlf from "../../assets/images/burning-alf.png";

interface Slug {
  current: string;
}

interface Color {
  hex: string;
}

interface Campaign {
  publishedAt: string;
  id: string;
  campaignTitle: string;
  campaignTitleDecoration: string;
  _rawCampaignLead: any[];
  slug: Slug;
  activeCampaign: boolean;
  bgColor: Color;
  textColor: Color;
}

const HostCampaign: Campaign = {
  publishedAt: "GIKK KREDITTKORTET VARMT I SOMMER?",
  id: "db99250c-1cf1-44e5-a855-ee922f9896fd",
  campaignTitle: "VI NEDBETALER 500 000 KRONER PÅ KREDITTGJELD",
  campaignTitleDecoration: "",
  _rawCampaignLead: [
    {
      _type: "block",
      children: [
        {
          _type: "span",
          text: "I oktober tar vi en halv million fra Horde-fondet. Kanskje er det du som vinner en varmende nedbetaling i høst?",
        },
      ],
    },
  ],

  slug: { current: "hostkampanje25" },
  activeCampaign: true,
  bgColor: { hex: COLORS.WHITE[100] },
  textColor: { hex: COLORS.WHITE[100] },
};

const HostCampaignShowCaseCard: React.FC = () => {
  const typographyColor = COLORS.BLACK[100];

  const components = {
    block: {
      // eslint-disable-next-line @typescript-eslint/no-shadow, react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
      normal: ({ children }: any) => (
        <Typography variant="body" color={COLORS.BLACK[100]}>
          {children}
        </Typography>
      ),
    },
  };

  return (
    <Grid2
      bgcolor={
        HostCampaign.campaignTitle === "hostkampanje25"
          ? COLORS.WHITE[100]
          : COLORS.WHITE[100]
      }
      borderRadius="20px"
      p={{ xs: "24px", md: "30px" }}
      display="flex"
      flexDirection="column-reverse"
      justifyContent="flex-end"
      alignItems="flex-start"
      gap="48px"
      style={{ position: "relative" }}
    >
      <Stack>
        <Stack
          spacing="24px"
          height={{ xs: "100%", md: "340px" }}
          justifyContent="space-between"
          alignItems="flex-start"
          maxWidth={{ xs: "100%", md: "430px" }}
        >
          <Stack gap="24px">
            <Stack>
              <Typography
                variant="loanInterestExampleDescription"
                color={COLORS.BLACK[100]}
                sx={{
                  textTransform: "none",
                }}
              >
                {HostCampaign.publishedAt}
              </Typography>
              <Typography
                fontFamily="erlik"
                variant="h2"
                color={typographyColor}
              >
                {HostCampaign.campaignTitle}
              </Typography>
            </Stack>

            <PortableText
              value={HostCampaign._rawCampaignLead}
              components={components}
            />
          </Stack>

          <Box alignItems="flex-start" paddingBottom="26px">
            <Button
              onClick={() => {
                navigate(`/gjeldfri/${HostCampaign.slug.current}`);
              }}
              variant="contained"
              // color="dark"
              endIcon={<ArrowForward />}
              sx={{
                border: "2px solid transparent",
                color: COLORS.WHITE[100],
                backgroundColor: COLORS.BLACK[100],
                "&:hover": {
                  border: "2px solid black",
                  color: COLORS.BLACK[100],
                  backgroundColor: COLORS.WHITE[100],
                },
              }}
            >
              Mer om kampanjen
            </Button>
          </Box>
        </Stack>
      </Stack>

      <Stack>
        <Stack
          component="img"
          src={BurningAlf}
          alt={HostCampaign.campaignTitle}
          sx={{
            width: "100%",
            objectFit: "cover",
            borderRadius: "20px",
          }}
        />
      </Stack>
    </Grid2>
  );
};

export default HostCampaignShowCaseCard;
